module.exports = __webpack_public_path__ + "img/mail.639a3013.png";